import "./story.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function Story() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="navbar-in" />
      <div className="our-story">
        <RevealOnScroll>
          <img
            src="https://i.imgur.com/XVcqfVA.jpeg"
            className="story-img"
            alt=""
          />
        </RevealOnScroll>

        <RevealOnScroll>
          <h1>OUR STORY</h1>
        </RevealOnScroll>

        <div className="locations">
          <RevealOnScroll delay={0.1}>
            <h3>Cafe Vista - Hoboken</h3>
            <p>
              Café Vista opened its doors in the summer of 2020 at 527 Monroe
              Street in Hoboken, quickly gaining well-deserved attention for its
              high-quality coffee, fresh pastries, delicious breakfast
              offerings, and thoughtfully designed, Instagram-worthy interior.
              <a href="https://cafevistahoboken.com/" target="_blank">
                Cafe Vista Hoboken
              </a>
            </p>
          </RevealOnScroll>

          <RevealOnScroll delay={0.1}>
            <h3>Dream Vista - Jersey City</h3>
            <p>
              One year later, in 2021, the second location—Dream Vista—opened in
              Jersey City. Now a neighborhood favorite, Dream Vista is known for
              its exceptional breakfast, premium coffee, and its spacious
              backyard, where families can relax and kids can play while parents
              enjoy their favorite drinks. It’s also a popular destination for
              hosting private events and parties.
              <a href="https://cafedreamvista.com/" target="_blank">
                Dream Vista
              </a>
            </p>
          </RevealOnScroll>

          <RevealOnScroll delay={0.1}>
            <h3>Cafe Vista - Ridgefield Park</h3>
            <p>
              After years of hard work and growth, founder Balsayat Jorayeva
              felt it was the right time to expand further—leading to the
              opening of Café Vista All-Day Dining & Café in Ridgefield Park.
              Located at 192 Main Street, this women-owned and operated café
              reflects Balsayat’s signature attention to detail and passion for
              hospitality. From the thoughtfully curated decor to the fresh,
              flavorful menu, every element of the space has been handpicked by
              Balsayat and her dedicated team. It’s more than just a café—it’s a
              welcoming, vibrant space designed to bring people together.
            </p>
          </RevealOnScroll>
        </div>

        <div className="approach">
          <RevealOnScroll delay={0.1}>
            <h3>Balsayat's Approach to Business</h3>
            <p>
              Balsayat is not only a hard worker but also a strong believer in
              teamwork. She knows that meaningful success is never achieved
              alone, and she places great value on building a supportive,
              collaborative environment. One of her greatest joys is seeing her
              team thrive in a peaceful, respectful workspace.
            </p>
          </RevealOnScroll>

          <RevealOnScroll delay={0.1}>
            <p>
              What makes her business approach unique is her belief that cafés
              shouldn’t be carbon copies of one another. Unlike the typical
              franchise model, Balsayat believes each neighborhood has its own
              unique identity and customer base—and every location should be
              tailored to reflect that.
            </p>
          </RevealOnScroll>

          <RevealOnScroll delay={0.1}>
            <p>
              Yet despite their differences, all her cafés share a familiar
              warmth and aesthetic. Each one carries the same welcoming vibe and
              thoughtful design that make Café Vista a brand guests love and
              trust.
            </p>
          </RevealOnScroll>
        </div>
        <div className="we-offer">
          <RevealOnScroll>
            <h3>What We Offer</h3>
          </RevealOnScroll>
          <RevealOnScroll>
            <p>
              Start your day with one of our carefully selected coffees and a
              fresh pastry—quick, delicious, and perfect for a busy morning.
            </p>
          </RevealOnScroll>
          <RevealOnScroll>
            <p>
              For breakfast, we offer a variety of options made with the
              freshest ingredients at fair prices. Whether you’re in the mood
              for omelets, avocado toasts, bagels, pancakes, or other comforting
              favorites, we have something to make your morning better.
            </p>
          </RevealOnScroll>
          <RevealOnScroll>
            <p>
              At lunch, you’ll find a wide selection of satisfying meals and
              refreshing drinks. We take pride in serving some of the best
              burgers, paninis, and sandwiches around. And if you try our
              Mediterranean-style chicken tacos, we promise—you’ll be hooked!
            </p>
          </RevealOnScroll>
          <RevealOnScroll>
            <p>
              We also offer a variety of delivery options for your convenience.
            </p>
          </RevealOnScroll>
          <RevealOnScroll>
            <p>
              Looking for a place to work or meet? Our beautifully designed café
              includes free Wi-Fi, making it a perfect spot for remote workers,
              freelancers, and business meetings alike. The cozy yet modern
              atmosphere makes it easy to focus or unwind.
            </p>
          </RevealOnScroll>
        </div>
      </div>
    </motion.div>
  );
}

export default Story;
